import { useLicensingServiceV1 } from "@rw1/api-services";
import { Licensing_V1 } from "@rw1/auto-generated-clients";
import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";
import { WHITELIST_BY_LICENSE_ID_QUERY_KEY } from "./useWhitelistByLicenseId";

export interface UseRemoveWhitelistedEmailsProps {
  licenseId: string;
  emails: string[];
  onSuccess?: () => void;
}

export const useRemoveWhitelistedEmails = (): UseMutationResult<
  void,
  Error,
  UseRemoveWhitelistedEmailsProps
> => {
  const licensingService = useLicensingServiceV1();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      licenseId,
      emails,
    }: UseRemoveWhitelistedEmailsProps) => {
      return await licensingService.removeEmailsFromLicenseWhitelist(
        licenseId,
        emails,
      );
    },
    onSuccess: (_, variables) => {
      queryClient.setQueryData(
        [WHITELIST_BY_LICENSE_ID_QUERY_KEY, variables.licenseId],
        (oldData: Licensing_V1.WhitelistEntry[] | undefined) => {
          return oldData?.filter(
            (entry) => !variables.emails.includes(entry.email),
          );
        },
      );

      void queryClient.invalidateQueries({
        queryKey: [WHITELIST_BY_LICENSE_ID_QUERY_KEY, variables.licenseId],
      });
      variables.onSuccess?.();
    },
  });
};
